import React from 'react'
import { GrTechnology } from 'react-icons/gr'
import TechnologyServicePage from '../components/TechnologyServicePage'

const capabilities = [
    { title: 'ERP Systems', description: 'Unify finance, operations, procurement, and reporting in one platform.' },
    { title: 'CRM Platforms', description: 'Manage leads, customers, service requests, and relationship data.' },
    { title: 'HRMS', description: 'Digitize employee records, workflows, attendance, and HR operations.' },
    { title: 'Financial Management', description: 'Improve budgeting, accounting, approvals, and financial visibility.' },
    { title: 'Supply Chain Systems', description: 'Track procurement, inventory, vendors, and fulfilment workflows.' },
    { title: 'Asset Management', description: 'Monitor organizational assets, lifecycle, maintenance, and accountability.' },
    { title: 'Document Management', description: 'Store, route, and control documents with faster digital access.' },
    { title: 'Workflow Automation', description: 'Automate approvals, tasks, notifications, and business processes.' },
    { title: 'BI Dashboards', description: 'Turn enterprise data into clear reports and executive dashboards.' }
]

const EnterpriseTechnologySolutions = () => (
    <TechnologyServicePage
        badge="Enterprise Technology Solutions"
        title="Integrated platforms for smarter enterprise operations."
        description="We design and deliver enterprise systems that connect people, processes, documents, data, and decisions across the organization."
        metaDescription="Enterprise ERP, CRM, HRMS, financial management, supply chain, document management, workflow automation, and BI dashboard solutions."
        icon={<GrTechnology className="text-sm" />}
        capabilities={capabilities}
        featuredVisual={{
            image: '/assets/erp360.jpg',
            alt: 'VRIFY ERP 360 Platform',
            eyebrow: 'Featured enterprise platform',
            title: 'Meet VRIFY ERP 360.',
            description: 'A connected enterprise management system that brings essential finance, operations, HR, supply chain, and reporting tools into one clear digital experience.',
            points: [
                'Finance, operations & HR',
                'Supply chain, procurement & inventory',
                'Document management & workflow',
            ]
        }}
        outcomes={[
            { title: 'Connected operations', description: 'Bring core departments and workflows into shared digital systems.' },
            { title: 'Better visibility', description: 'Give leaders dashboards, reports, and real-time operational insight.' },
            { title: 'Scalable control', description: 'Standardize processes as teams, branches, and transactions grow.' }
        ]}
        highlights={[
            { title: 'Unify', description: 'Connect enterprise data, users, workflows, and departments.' },
            { title: 'Automate', description: 'Reduce manual approvals, repeated tasks, and disconnected documents.' },
            { title: 'Inform', description: 'Use business intelligence to support faster executive decisions.' }
        ]}
        cta={{
            eyebrow: 'Enterprise ready',
            title: 'Run your organization on connected, measurable systems.',
            description: 'We help enterprises replace scattered tools with platforms that scale.'
        }}
    />
)

export default EnterpriseTechnologySolutions
